import styled, { css } from 'styled-components'
import { Color } from '../../config/styles/colors'
import Button from '../Button'

const visibilityStyling = css<{ show?: boolean }>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  opacity: ${({ show }) => (show ? 1 : 0)};
`

const acceptBtn = css`
  background: ${Color.PALE_GREEN} !important;
  border: 1px solid #000 !important;
  color: #000 !important;
`
const declineBtn = css`
  background: ${Color.RED} !important;
  border: 1px solid #000 !important;
  color: #fff !important;
`

export const Banner = styled.div<{ show?: boolean }>`
  position: absolute;
  z-index: 2;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5em;

  bottom: 0;

  > :nth-child(n) {
    margin: 0 !important;
  }

  padding: 1em 1.5em;

  @media only screen and (max-width: 22.5em) {
    padding: 0.8em 1em;

    .title {
      font-size: 0.8em !important;
    }

    .content {
      font-size: 0.7em !important;
      padding: 0.5em 0;
    }

    .learn-more {
      font-size: 0.7em !important;
      padding: 0.2em 0;
    }
  }

  ${visibilityStyling};

  background: #fff;

  width: 100%;
  max-width: fit-content;
  max-width: -webkit-fill-available;
  height: auto;

  .title {
    font-size: 1em;
    margin-top: 0;
    text-align: center;
  }

  .content {
    text-align: center;
    font-size: 0.8em;
  }

  .learn-more {
    font-size: 0.8em;
    text-align: center;

    .link {
      color: #318ce7 !important;
    }
  }

  .banner-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em;
  }
`

export const Btn = styled(Button)<{ userAction?: string }>`
  ${({ userAction }) => (userAction === 'accept' ? acceptBtn : declineBtn)};
`
